<app-section-select
    scope="public"
    [canDrag]="true"
    [params]="params"
    [defaultSorting]="defaultSorting"
    sync_all_key="sync_all"
    attachKey="attach_ids"
    detachKey="detach_ids"
    [columns]="['select', 'title', 'updated_at', 'academy_name', 'status']"
    [accessForm]="accessForm"
    [referenceFilter]="referenceFilter"
></app-section-select>
